import React from 'react';
import { useTranslation } from 'react-i18next';
import { PhysicalProduct } from '../common/model/dto/physical-product/physical-product';
import { RecordColumn } from '../common/model/ui/record-list.type';
import DateUtils from '../common/utils/services/date-utils';
import StringUtils from '../common/utils/services/string-utils';
import OvPillLink from '../components/UI/atoms/OvPillLink';

export function usePhysicalProductListColumns(
  getNavigationState: () => unknown
): RecordColumn<PhysicalProduct>[] {
  const { t } = useTranslation();

  return [
    {
      id: 'internal-name',
      header: t('physicalProducts.fields.internalName'),
      cardRole: 'heading',
      renderCell: (product) => StringUtils.displayValue(product.internal_name),
    },
    {
      id: 'sku',
      header: t('physicalProducts.fields.sku'),
      renderCell: (product) => StringUtils.displayValue(product.sku),
    },
    {
      id: 'display-price',
      header: t('physicalProducts.fields.displayPrice'),
      renderCell: (product) => StringUtils.displayValue(product.display_price),
    },
    {
      id: 'is-active',
      header: t('physicalProducts.fields.isActive'),
      renderCell: (product) =>
        StringUtils.getPrettifiedBooleanValue(product.is_active),
    },
    {
      id: 'platform',
      header: t('physicalProducts.fields.platform'),
      renderCell: (product) => StringUtils.displayValue(product.platform),
    },
    {
      id: 'type',
      header: t('physicalProducts.fields.type'),
      renderCell: (product) => StringUtils.displayValue(product.type),
    },
    {
      id: 'countries',
      header: t('physicalProducts.fields.countries'),
      renderCell: (product) =>
        product.countries
          ? StringUtils.displayValue(`${product.countries}`)
          : '-',
    },
    {
      id: 'created-at',
      header: t('physicalProducts.fields.createdAt'),
      renderCell: (product) =>
        DateUtils.formatDate(product.created_at, 'MMMM DD, YYYY, HH:mm:ss'),
    },
    {
      id: 'action',
      header: t('common.action'),
      isHeaderHidden: true,
      cardRole: 'footer',
      renderCell: (product, detailsPath = '') => (
        <OvPillLink
          to={detailsPath}
          state={getNavigationState()}
          aria-label={t('physicalProducts.detailsFor', {
            name: product.internal_name,
          })}
        >
          {t('common.actions.seeDetails')}
        </OvPillLink>
      ),
    },
  ];
}
